module.exports = __webpack_public_path__ + "static/img/weezie_bi.ff2970a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/weezie_bi.png
// module id = ./src/assets/logos/weezie_bi.png
// module chunks = 1